import { styled } from 'styled-components';
import { motion } from 'framer-motion';

export const InfoWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${props => props.theme.spaceLg};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceLg};

  h1,
  p {
    text-align: center;
  }

  li {
    font-size: ${props => props.theme.sizeSmall};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    li {
      font-size: ${props => props.theme.sizeBody};
    }
  }
`;

export const PricingButton = styled.button`
  padding: ${props => `${props.theme.spaceSm} ${props.theme.spaceMd}`};

  font-size: 0.8rem;
  font-weight: 500;

  ${props =>
    props.$active
      ? `
    color: ${props.theme.backgroundColor};
    background-color: ${props.theme.brand};
    border-color: ${props.theme.brand};
  `
      : `
    color: ${props.theme.mutedColor};
    background-color: transparent;
    border-color: ${props.theme.mutedColor};

    &:hover {
      color: ${props.theme.textColor};
      border-color: ${props.theme.textColor};
    }
  `}

  border-width: 2px;
  border-style: solid;
`;

export const PricingForm = styled(motion.div)`
  margin-bottom: calc(${props => `${props.theme.spaceSm} + 4px + ${props.theme.spaceMd}`});
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
`;

export const PriceWrapper = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${props => props.theme.spaceMd};
`;

export const VTuberInfo = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceMd};
  padding: ${props => `${props.theme.spaceMd}`};
  background-color: ${props => props.theme.backgroundColor};
  border-radius: ${props => props.theme.borderRadiusMd};
`;